module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/cotb-2018.json
// module id = 326
// module chunks = 195789369530597